export default __webpack_public_path__ + "eb02045c9cb7e55edf76c637d234e614.svg";